import { FC } from 'react'
/* Helpers */
import { reduceAddress } from '../lib/helpers'

/* Assets */
import arrow from '../images/arrow-link.svg'
import close from '../images/close.svg'
import tick from '../images/tick.svg'
import spinner from '../images/etherscan-spinner.svg'
import { getTransactionUrl } from '../constants/chainScanners'

export type TransactionStatus = 'passed' | 'failed' | 'pending'

type TxDetailProps = {
  hash: string
  status: TransactionStatus
  chain_id: number
}

const TxDetail: FC<TxDetailProps> = ({ hash, status, chain_id }) => {
  const getStatusElement = () => {
    switch (status) {
      case 'passed':
        return (
          <div className={'info-tx info-success'}>
            <img src={tick} alt={'Success'} />
            Success
          </div>
        )
      case 'failed':
        return (
          <div className={'info-tx info-error'}>
            <img src={close} alt={'Failed'} />
            Failed
          </div>
        )
      default:
        return (
          <div className={'info-tx info-pending'}>
            <img src={spinner} alt={'Mining'} />
            Pending
          </div>
        )
    }
  }

  const statusElement = getStatusElement()

  return (
    <div className={'tx-detail'} data-aos="fade-up" data-aos-delay="300">
      <div className={'tx-detail-box'}>
        <div className={'tx-detail-cell'}>
          <div className={'tx-detail-cell-title'}>Hash</div>
          <a href={getTransactionUrl(chain_id, hash)} target={'_blank'} rel="noopener noreferrer">
            {reduceAddress(hash)}
            <img src={arrow} alt={'Link'} />
          </a>
        </div>
        <div className={'tx-detail-cell'}>
          <div className={'tx-detail-cell-title'}>Status</div>
          <div>{statusElement}</div>
        </div>
      </div>
    </div>
  )
}

export { TxDetail }
